import { render, staticRenderFns } from "./FreebiesCreatePage.vue?vue&type=template&id=022013dc"
import script from "./FreebiesCreatePage.vue?vue&type=script&lang=js"
export * from "./FreebiesCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports